<template>
  <v-dialog max-width="500" elevation="10" style="backdrop-filter: grayscale(1) blur(2px)">
    <template v-slot:activator="{ props: activatorProps }">
      <v-sheet style="cursor: pointer" color="green" class="d-flex justify-space-between align-center pa-2" width="100%" height="30" v-bind="activatorProps">
        <v-icon class="mr-1" :icon="['fas', 'sort']" />
        <p>{{ sort_by ?  'По '+sort_by.name.toLowerCase()+'у' : 'СОРТИРОВКА' }}</p>
        <v-spacer />
        <v-chip density="compact" size="small" color="white" variant="flat" class="mr-1" v-if=" sort_by">
          <span v-if="!reverse_direction">ВОЗР</span>
          <span v-else>УБЫВ</span>
        </v-chip>
      </v-sheet>
    </template>

    <template v-slot:default>
      <v-card rounded="xl">
        <template v-slot:title>
          <p>{{ sort_by ?  'По '+sort_by.name.toLowerCase()+'у' : 'СОРТИРОВКА' }}</p>
        </template>
        <template v-slot:text>
          <v-card density="compact" class="mb-1" :class="{'px-2' : sort_by && element.field === sort_by.field, 'mx-4' : sort_by && element.field !== sort_by.field }" flat v-for="element of list_of_sorting_fields" :key="element" :color="sort_by ? (element.field === sort_by.field ? 'green' : 'grey-lighten-2') : 'grey-lighten-2'" v-on:click="select_sorting(element)">
            <template v-slot:title>
              <span style="font-size: 14px">{{ element.name }}</span>
            </template>
            <template v-slot:append>
              <v-chip size="small" density="compact" color="white" variant="flat" v-if="sort_by && element.field === sort_by.field">
                <span v-if="!reverse_direction">А-Я</span>
                <span v-else>Я-А</span>
              </v-chip>
            </template>
          </v-card>
        </template>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import { SortBy, SortDirReverse } from "@/store/wp_planner/info.store";
import { FiltersBlock } from "@/store/wp_planner/filters.store";
import { App_Documents } from "@/store/wp_planner/documents.store";

export default {
  name: "Sorter__WP_Module",
  data() {
    return {
      list_of_sorting_fields: [
        {
          name: 'Приоритет',
          field: 'priority',
          group: false,
          type: 'number'
        },
        {
          name: 'Физ. Объект',
          field: 'object',
          group: true,
          type: 'object'
        },
        {
          name: 'Договор',
          field: 'contract',
          group: true,
          type: 'object'
        },
        {
          name: 'Тип.работ',
          field: 'worktype',
          group: true,
          type: 'object'
        }
      ]
    }
  },
  methods: {
    select_sorting: function (element) {
      if (this.sort_by) {
        if (this.sort_by === element) {
          if (this.reverse_direction) {
            this.sort_by = null
            this.reverse_direction = false
          } else {
            this.reverse_direction = true
          }
        } else {
          this.sort_by = element
          this.reverse_direction = false
        }
      } else {
        this.sort_by = element
      }
    }
  },
  computed: {
    filtered() {
      let docs = this.documents
      if (this.selected_filters.length > 0) {
        for (let filter of this.selected_filters) {
          docs = docs.filter(document => filter.data.includes(document[filter.id].guid))
        }
        return docs
      } else {
        return this.documents
      }
    },
    selected_filters() {
      return FiltersBlock().selected()
    },
    documents: {
      get() {
        return App_Documents().get()
      },
      set(value) {
        App_Documents().set(value)
      }
    },
    sort_by: {
      get() {
        return SortBy().get()
      },
      set(value) {
        SortBy().set(value)
      }
    },
    reverse_direction: {
      get() {
        return SortDirReverse().get()
      },
      set(value) {
        SortDirReverse().set(value)
      }
    },
  }
}
</script>

<style scoped>
.sort-button {
  cursor: pointer !important;
  transition: 0.2s;
}

.sort-button:hover {
  color: red;
}
</style>
